import $ from "jquery";
import { Klass, u_ } from "@pressmedia/webappbase";
import vuwer from "@pressmedia/vuwer";
import "@pressmedia/vuwcolony";

const { app } = window;

function addList(vuw, module) {
	if( !( vuw instanceof Klass("Vuw") ) ) {
		throw new TypeError("arguments[0] must be Vuw instance.");
	}
	if( !( module instanceof Klass("TyrellModule") ) ) {
		throw new TypeError("arguments[0] must be TyrellModule instance.");
	}
	
	vuw.add("list", {
		vuwType: "colony",
		
		selector() {
			return this.container.$self.children("tbody");
		},
		
		module,
		autoLoad: false,
		
		// ページ指定のクエリ文字列
		pageQuery: "p",
		
		// ページャーの表示・非表示
		showPager: true,
		
		// ページャーから除外するクエリ文字列
		excludeQueryFromPager: ["i", "v"],
		
		// 記事表示用の関数（未指定の場合はテンプレートから生成）
		initArticle(item, config, $artcl, module) {
			$artcl.children("td").each((i, elm) => {
				const pk = elm.className.split(" ")[0].replace(/^col-/, "");
				const pi = config.dataParams[pk];
				if(pi && pi.inpType === "flg") {
					const inpType = !pi.isUnique ? "checkbox" : "radio";
					const $inp = $("<input/>").attr({
						id: ["flg", pk, item.itemId].join("_"),
						type: inpType,
						name: pk
					}).prop("checked", !!item[pk])
					.addClass(`inp inp-${inpType} flg-${pk}`).val("1");
					
					$("<span/>").addClass("field-inp").append(
						$inp,
						$("<label/>").attr("for", $inp.attr("id"))
					).appendTo( $(elm).empty() );
				}
			});
			
			// [管理機能]
			const fltrs = { ...(config.fltrs || {}) };
			const { keywordQuery } = app.fm.search;
			
			if( keywordQuery !== "KEYWORD" && u_.hasProperty(fltrs, "KEYWORD") ) {
				fltrs[keywordQuery] = fltrs.KEYWORD;
				delete fltrs.KEYWORD;
			}
			
			if( u_.hasProperty(app._GET, this.pageQuery) ) {
				fltrs[this.pageQuery] = app._GET[this.pageQuery];
			}
			
			// 確認ボタン
			const $btns = $artcl.children(".col-func").children(".area-btns");
			const $btnPreview = $btns.children(".btn-preview");
			if($btnPreview.length) {
				fltrs.v = "preview";
				fltrs.i = item.itemId;
				$btnPreview.attr({
					href: app.URL + u_.createQueryString(fltrs)
				});
			}
			
			// 修正ボタン
			const $btnEdit = $btns.children(".btn-edit");
			if($btnEdit.length) {
				fltrs.v = "edit";
				fltrs.i = item.itemId;
				$btnEdit.attr({
					href: app.URL + u_.createQueryString(fltrs)
				});
			}
			
			// 削除ボタン
			const $btnDelete = $btns.children(".btn-delete");
			if($btnDelete.length) {
				delete fltrs.v;
				delete fltrs.i;
				fltrs.del = item.itemId;
				$btnDelete.attr({
					href: app.URL + u_.createQueryString(fltrs)
				});
				delete fltrs.del;
			}
			
			$artcl.attr({
				"id": ["item", item.itemId].join("_"),
				"data-id": item.itemId
			});
		},
		
		onReady($self) {
			// add event listener
			$self
			// 確認ボタン
			.on("click", ".btn-preview", e => {
				e.preventDefault();
				
				const $btn = $(e.currentTarget).trigger("blur");
				if( $btn.hasClass("is-disable") ) {
					return false;
				}
				
				vuwer.setState(
					u_.parseQueryString(e.currentTarget.search)
				);
			})
			
			// 修正ボタン
			.on("click", ".btn-edit", e => {
				e.preventDefault();
				
				const $btn = $(e.currentTarget).trigger("blur");
				if( $btn.hasClass("is-disable") ) {
					return false;
				}
				
				vuwer.setState(
					u_.parseQueryString(e.currentTarget.search)
				);
			})
			
			// 削除ボタン
			.on("click", ".btn-delete", e => {
				e.preventDefault();
				
				const $btn = $(e.currentTarget).trigger("blur");
				if( $btn.hasClass("is-disable") ) {
					return false;
				}
				
				let msg = "データを削除します。<br/>よろしいですか？";
				const itemId = u_.parseQueryString(e.currentTarget.search).del;
				
				if(this.module.config.dataParams.itemId) {
					msg = `「${this.module.items.byId[itemId].itemId}」の${msg}`;
				} else {
					msg = `選択した${msg}`;
				}
				
				const $rec = $btn.closest("tr").addClass("confirm-delete");
				
				app.confirm(msg, async () => {
					await Promise.all([
						app.showLoading("delete"),
						new Promise(resolve => {
							$rec.addClass("fadeout");
							const delay = parseFloat( $rec.css("transition-duration") ) * 1000;
							setTimeout(resolve, delay);
						}),
						this.module.deleteItem(itemId)
					]);
					
					$rec.hide();
					
					// リストを再生成
					await app.initList();
					
					app.hideLoading("delete");
					
				}, () => $rec.removeClass("confirm-delete"));
			})
			
			// [flg] on/offの切り替え
			.on("change", "[data-type='flg'] .inp", (e, isTrigger) => {
				const elm = e.currentTarget;
				const isOn = elm.checked;
				const pk = elm.name;
				const $inp = $(elm).trigger("blur");
				
				const pi = this.module.config.dataParams[pk];
				const $rec = $inp.closest("tr");
				const itemId = $rec.data("id");
				
				if( !isTrigger && pi.isUnique && this.module.items.byId[itemId][pk] ) {
					// flgが既にonのデータの場合、処理をスキップ (for IE legacy)
					// ※トリガー時は除く
					elm.checked = !isOn;
					return false;
				}
				
				const disp = pi.dataOption[isOn ? 1 : 0];
				const msg = `選択したデータを「${disp}」に変更します。<br/>よろしいですか？`;
				
				app.confirm(msg, async () => {
					// OK
					$rec.toggleClass(`${pk}-on`, isOn).toggleClass(`${pk}-off`, !isOn);
					
					app.saveScroll();
					
					await Promise.all([
						app.showLoading(`change flg: ${pk}`),
						this.module.changeItemFlg(itemId, pk)
					])
					.then(() => app.initList())
					.catch(() => {
						// error
						if(pi.isUnique) {
							return app.initList();
						} else {
							// restore
							$inp.prop("checked", !isOn);
							$rec.toggleClass(`${pk}-on`, !isOn).toggleClass(`${pk}-off`, isOn);
						}
					});
					
					return app.loadScroll().hideLoading(`change flg: ${pk}`);
				}, () => {
					// Cancel
					if(pi.isUnique) {
						return app.initList();
					} else {
						$inp.prop("checked", !isOn);
					}
				});
			});
			
			return this;
		}
	}, function() {
		const vuwPager = this.get("pager");
		vuwPager && vuwPager.onReady($self => {
			$self.insertAfter(this.container.$self);
		});
	});
}

export default addList;
